export const getUserGroupFormValues = (userGroup = {}) => ({
  ...userGroup,
  client_app_role_id:
    userGroup.client_app_role_id ?? userGroup.client_app_roles?.[0]?.id ?? "",
});
